// African Countries
export const africanCountries = [
  "Algeria", "Angola", "Benin", "Botswana", "Burkina Faso", "Burundi", 
  "Cameroon", "Cape Verde", "Central African Republic", "Chad", "Comoros", 
  "Democratic Republic of the Congo", "Republic of the Congo", "Côte d'Ivoire", 
  "Djibouti", "Egypt", "Equatorial Guinea", "Eritrea", "Eswatini", "Ethiopia", 
  "Gabon", "Gambia", "Ghana", "Guinea", "Guinea-Bissau", "Kenya", "Lesotho", 
  "Liberia", "Libya", "Madagascar", "Malawi", "Mali", "Mauritania", "Mauritius", 
  "Morocco", "Mozambique", "Namibia", "Niger", "Nigeria", "Rwanda", 
  "São Tomé and Príncipe", "Senegal", "Seychelles", "Sierra Leone", "Somalia", 
  "South Africa", "South Sudan", "Sudan", "Tanzania", "Togo", "Tunisia", 
  "Uganda", "Zambia", "Zimbabwe"
];

// Kenya Counties with their cities/towns and sub-counties
export const kenyaData = {
  "Nairobi": {
    cities: ["Nairobi City"],
    subcounties: ["Westlands", "Dagoretti North", "Dagoretti South", "Langata", "Kibra", "Roysambu", "Kasarani", "Ruaraka", "Embakasi South", "Embakasi North", "Embakasi Central", "Embakasi East", "Embakasi West", "Makadara", "Kamukunji", "Starehe", "Mathare"]
  },
  "Mombasa": {
    cities: ["Mombasa City"],
    subcounties: ["Changamwe", "Jomvu", "Kisauni", "Nyali", "Likoni", "Mvita"]
  },
  "Kisumu": {
    cities: ["Kisumu City"],
    subcounties: ["Kisumu East", "Kisumu West", "Kisumu Central", "Seme", "Nyando", "Muhoroni", "Nyakach"]
  },
  "Nakuru": {
    cities: ["Nakuru City", "Naivasha"],
    subcounties: ["Nakuru Town East", "Nakuru Town West", "Naivasha", "Gilgil", "Molo", "Njoro", "Rongai", "Subukia", "Bahati", "Kuresoi North", "Kuresoi South"]
  },
  "Kiambu": {
    cities: ["Thika", "Ruiru", "Kikuyu", "Limuru"],
    subcounties: ["Gatundu South", "Gatundu North", "Juja", "Thika Town", "Ruiru", "Githunguri", "Kiambu", "Kiambaa", "Kabete", "Kikuyu", "Limuru", "Lari"]
  },
  "Machakos": {
    cities: ["Machakos", "Athi River"],
    subcounties: ["Machakos Town", "Mavoko", "Masinga", "Yatta", "Kangundo", "Matungulu", "Kathiani", "Mwala"]
  },
  "Kajiado": {
    cities: ["Kajiado", "Ngong", "Kitengela", "Ongata Rongai"],
    subcounties: ["Kajiado Central", "Kajiado North", "Kajiado East", "Kajiado West", "Kajiado South"]
  },
  "Uasin Gishu": {
    cities: ["Eldoret"],
    subcounties: ["Soy", "Turbo", "Moiben", "Ainabkoi", "Kapseret", "Kesses"]
  },
  "Trans Nzoia": {
    cities: ["Kitale"],
    subcounties: ["Kwanza", "Endebess", "Saboti", "Kiminini", "Cherangany"]
  },
  "Kakamega": {
    cities: ["Kakamega"],
    subcounties: ["Lugari", "Likuyani", "Malava", "Navakholo", "Lurambi", "Ikolomani", "Shinyalu", "Khwisero", "Butere", "Mumias West", "Mumias East", "Matungu"]
  },
  "Bungoma": {
    cities: ["Bungoma"],
    subcounties: ["Mt. Elgon", "Sirisia", "Kabuchai", "Bumula", "Kanduyi", "Webuye East", "Webuye West", "Kimilili", "Tongaren"]
  },
  "Nyeri": {
    cities: ["Nyeri"],
    subcounties: ["Tetu", "Kieni East", "Kieni West", "Mathira East", "Mathira West", "Nyeri Town", "Mukurweini", "Othaya"]
  },
  "Meru": {
    cities: ["Meru"],
    subcounties: ["Igembe South", "Igembe Central", "Igembe North", "Tigania West", "Tigania East", "North Imenti", "Buuri", "Central Imenti", "South Imenti"]
  },
  "Kilifi": {
    cities: ["Kilifi", "Malindi"],
    subcounties: ["Kilifi North", "Kilifi South", "Kaloleni", "Rabai", "Ganze", "Malindi", "Magarini"]
  },
  "Kwale": {
    cities: ["Kwale", "Ukunda"],
    subcounties: ["Msambweni", "Lunga Lunga", "Matuga", "Kinango"]
  },
  "Taita Taveta": {
    cities: ["Voi", "Taveta"],
    subcounties: ["Taveta", "Wundanyi", "Mwatate", "Voi"]
  },
  "Garissa": {
    cities: ["Garissa"],
    subcounties: ["Garissa Township", "Balambala", "Lagdera", "Dadaab", "Fafi", "Ijara"]
  },
  "Wajir": {
    cities: ["Wajir"],
    subcounties: ["Wajir North", "Wajir East", "Tarbaj", "Wajir West", "Eldas", "Wajir South"]
  },
  "Mandera": {
    cities: ["Mandera"],
    subcounties: ["Mandera West", "Banissa", "Mandera North", "Mandera South", "Mandera East", "Lafey"]
  },
  "Marsabit": {
    cities: ["Marsabit", "Moyale"],
    subcounties: ["Moyale", "North Horr", "Saku", "Laisamis"]
  },
  "Isiolo": {
    cities: ["Isiolo"],
    subcounties: ["Isiolo North", "Isiolo South"]
  },
  "Samburu": {
    cities: ["Maralal"],
    subcounties: ["Samburu West", "Samburu North", "Samburu East"]
  },
  "Turkana": {
    cities: ["Lodwar"],
    subcounties: ["Turkana North", "Turkana West", "Turkana Central", "Loima", "Turkana South", "Turkana East"]
  },
  "West Pokot": {
    cities: ["Kapenguria"],
    subcounties: ["Kapenguria", "Sigor", "Kacheliba", "Pokot South"]
  },
  "Baringo": {
    cities: ["Kabarnet"],
    subcounties: ["Tiaty", "Baringo North", "Baringo Central", "Baringo South", "Mogotio", "Eldama Ravine"]
  },
  "Elgeyo Marakwet": {
    cities: ["Iten"],
    subcounties: ["Marakwet East", "Marakwet West", "Keiyo North", "Keiyo South"]
  },
  "Nandi": {
    cities: ["Kapsabet"],
    subcounties: ["Chesumei", "Nandi Hills", "Emgwen", "Mosop", "Aldai", "Tinderet"]
  },
  "Laikipia": {
    cities: ["Nanyuki", "Nyahururu"],
    subcounties: ["Laikipia West", "Laikipia East", "Laikipia North"]
  },
  "Nyandarua": {
    cities: ["Ol Kalou"],
    subcounties: ["Kinangop", "Kipipiri", "Ol Kalou", "Ol Joro Orok", "Ndaragwa"]
  },
  "Murang'a": {
    cities: ["Murang'a"],
    subcounties: ["Kangema", "Mathioya", "Kiharu", "Kigumo", "Maragua", "Kandara", "Gatanga"]
  },
  "Kirinyaga": {
    cities: ["Kerugoya", "Kutus"],
    subcounties: ["Mwea", "Gichugu", "Ndia", "Kirinyaga Central"]
  },
  "Embu": {
    cities: ["Embu"],
    subcounties: ["Manyatta", "Runyenjes", "Mbeere South", "Mbeere North"]
  },
  "Tharaka Nithi": {
    cities: ["Chuka"],
    subcounties: ["Maara", "Chuka/Igambang'ombe", "Tharaka"]
  },
  "Kitui": {
    cities: ["Kitui"],
    subcounties: ["Mwingi North", "Mwingi West", "Mwingi Central", "Kitui West", "Kitui Rural", "Kitui Central", "Kitui East", "Kitui South"]
  },
  "Makueni": {
    cities: ["Wote"],
    subcounties: ["Mbooni", "Kilome", "Kaiti", "Makueni", "Kibwezi West", "Kibwezi East"]
  },
  "Kericho": {
    cities: ["Kericho"],
    subcounties: ["Ainamoi", "Belgut", "Bureti", "Kipkelion East", "Kipkelion West", "Sigowet/Soin"]
  },
  "Bomet": {
    cities: ["Bomet"],
    subcounties: ["Sotik", "Chepalungu", "Bomet East", "Bomet Central", "Konoin"]
  },
  "Narok": {
    cities: ["Narok"],
    subcounties: ["Kilgoris", "Emurua Dikirr", "Narok North", "Narok East", "Narok South", "Narok West"]
  },
  "Kisii": {
    cities: ["Kisii"],
    subcounties: ["Bonchari", "South Mugirango", "Bomachoge Borabu", "Bobasi", "Bomachoge Chache", "Nyaribari Masaba", "Nyaribari Chache", "Kitutu Chache North", "Kitutu Chache South"]
  },
  "Nyamira": {
    cities: ["Nyamira"],
    subcounties: ["Kitutu Masaba", "West Mugirango", "North Mugirango", "Borabu"]
  },
  "Migori": {
    cities: ["Migori"],
    subcounties: ["Rongo", "Awendo", "Suna East", "Suna West", "Uriri", "Nyatike", "Kuria West", "Kuria East"]
  },
  "Homa Bay": {
    cities: ["Homa Bay"],
    subcounties: ["Kasipul", "Kabondo Kasipul", "Karachuonyo", "Rangwe", "Homa Bay Town", "Ndhiwa", "Suba North", "Suba South"]
  },
  "Siaya": {
    cities: ["Siaya"],
    subcounties: ["Ugenya", "Ugunja", "Gem", "Bondo", "Rarieda", "Alego Usonga"]
  },
  "Busia": {
    cities: ["Busia"],
    subcounties: ["Teso North", "Teso South", "Nambale", "Matayos", "Butula", "Funyula", "Budalangi"]
  },
  "Vihiga": {
    cities: ["Vihiga"],
    subcounties: ["Vihiga", "Sabatia", "Hamisi", "Luanda", "Emuhaya"]
  },
  "Lamu": {
    cities: ["Lamu"],
    subcounties: ["Lamu East", "Lamu West"]
  },
  "Tana River": {
    cities: ["Hola"],
    subcounties: ["Garsen", "Galole", "Bura"]
  }
};

// Sample data for other countries (major cities)
export const otherCountriesData = {
  "Nigeria": {
    cities: ["Lagos", "Abuja", "Kano", "Ibadan", "Port Harcourt", "Benin City", "Kaduna", "Enugu", "Onitsha", "Jos"]
  },
  "South Africa": {
    cities: ["Johannesburg", "Cape Town", "Durban", "Pretoria", "Port Elizabeth", "Bloemfontein", "East London", "Pietermaritzburg"]
  },
  "Ghana": {
    cities: ["Accra", "Kumasi", "Tamale", "Takoradi", "Tema", "Cape Coast", "Koforidua", "Sunyani"]
  },
  "Tanzania": {
    cities: ["Dar es Salaam", "Dodoma", "Mwanza", "Arusha", "Mbeya", "Morogoro", "Tanga", "Zanzibar City"]
  },
  "Uganda": {
    cities: ["Kampala", "Entebbe", "Jinja", "Mbarara", "Gulu", "Lira", "Mbale", "Fort Portal"]
  },
  "Ethiopia": {
    cities: ["Addis Ababa", "Dire Dawa", "Mekelle", "Gondar", "Hawassa", "Bahir Dar", "Adama", "Jimma"]
  },
  "Rwanda": {
    cities: ["Kigali", "Butare", "Gisenyi", "Ruhengeri", "Gitarama", "Byumba"]
  },
  "Egypt": {
    cities: ["Cairo", "Alexandria", "Giza", "Shubra El Kheima", "Port Said", "Suez", "Luxor", "Aswan"]
  },
  "Morocco": {
    cities: ["Casablanca", "Rabat", "Fes", "Marrakech", "Tangier", "Agadir", "Meknes", "Oujda"]
  },
  "Algeria": {
    cities: ["Algiers", "Oran", "Constantine", "Annaba", "Blida", "Batna", "Djelfa", "Sétif"]
  }
};

// Default schools/academies (placeholder - will be updated with CSV data)
export const defaultSchools = [
  "Alliance High School",
  "Kenya High School",
  "Starehe Boys Centre",
  "Nairobi School",
  "Moi Girls High School Eldoret",
  "Kakamega High School",
  "Mangu High School",
  "St. Mary's School Nairobi",
  "Lenana School",
  "Precious Blood Riruta",
  "Strathmore School",
  "Brookhouse School",
  "Hillcrest International School",
  "Braeburn Schools",
  "Rift Valley Academy",
  "Kapsabet Boys High School",
  "Moi Forces Academy",
  "Other"
];

export const defaultAcademies = [
  "Mathare Youth Sports Association",
  "Ligi Ndogo Sports Academy",
  "Mwamba RFC Academy",
  "Kenya Rugby Union Academy",
  "Gor Mahia Youth Academy",
  "AFC Leopards Academy",
  "Tusker FC Academy",
  "Kenya Swimming Federation Academy",
  "Athletics Kenya Development Centre",
  "Kenya Tennis Academy",
  "Kenya Basketball Association Academy",
  "Padel Kenya Academy",
  "Other"
];
